module.exports = __webpack_public_path__ + "static/media/water_200_detail_02.4d17efa5.jpg";